<template>
  <TableBodyRow
    :data-tst="`custom_reports_table_row_${index}`"
    :thead="thead"
    class="gw_table_body_row_hoverable gw_hvr"
    @click="handleApplyClick"
  >
    <TableBodyCell
      thKey="name"
      style="--padding-td: 0 0.5rem 0 0.25rem"
      @click.stop
    >
      <GwTableInputMenu
        :text="item.name || ''"
        @confirm="text => patchName(text)"
      >
        <template #text>
          <div
            v-if="item.name"
            class="truncate"
            :title="item.name"
          >
            {{ item.name }}
          </div>
          <div
            v-else
            class="clr-grey truncate"
          >
            {{ $t('hhv3.report_name') }}
          </div>
        </template>
      </GwTableInputMenu>
    </TableBodyCell>

    <TableBodyCell thKey="created_at">
      <div class="truncate">
        {{ formatISODate(item.created_at, {}) }}
      </div>
    </TableBodyCell>

    <TableBodyCell thKey="positions">
      <div
        class="truncate"
        v-html="
          $t(`solfigr.oop_vs_ip`, {
            oop: getPlayerHtmlPosition(item.players[0].relative_position),
            ip: getPlayerHtmlPosition(item.players[1].relative_position),
          })
        "
      ></div>
    </TableBodyCell>

    <TableBodyCell thKey="model">
      <div class="truncate">{{ item.format }}</div>
    </TableBodyCell>

    <TableBodyCell thKey="actions">
      <StreetActionsCompacted
        v-if="item.preflop_actions"
        :streets="{
          preflop_actions: item.preflop_actions.split('-'),
        }"
      />
      <div
        class="gw_btn text-medium weight_500 gw_hvr_content"
        style="position: absolute; right: 0.25rem"
      >
        <div class="mdi mdi-chevron-double-right mr-1"></div>
        {{ $t('btn.apply') }}
      </div>
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import StreetActionsCompacted from '@/components/StreetActionsCompacted/StreetActionsCompacted'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import formatMix from '@/mixins/format_mix'
import GwTableInputMenu from '@/components/DataTables/v2/GwTableInputMenu'

export default {
  name: 'CustomReportsTableRow',
  components: {
    TableBodyRow,
    TableBodyCell,
    StreetActionsCompacted,
    GwTableInputMenu,
  },
  mixins: [formatMix],
  props: {
    item: Object,
    index: Number,
    thead: Object,
  },
  emits: ['apply:item', 'patch:name'],
  methods: {
    patchName(text) {
      this.$emit('patch:name', { item: this.item, name: text })
    },
    handleApplyClick() {
      this.$emit('apply:item', this.item)
    },
  },
}
</script>
